export default {
      id: "i-search-new-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/sprite.svg#i-search-new",
      toString: function () {
        return this.url;
      }
    }